import GLOBAL from './GLOBAL';

/**
 * @returns {string} User agent
 */
const getUserAgent = () => GLOBAL.getNavigator().userAgent;

export default getUserAgent;
